/** Signed win link (`/w/:winId?exp&sig`, §12.2): `getWinLink(winId, { exp, sig })`; prize + lottery + claim status, never contact details. */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const WinLinkPage = lazyRoute(() => import('./WinLinkPage'));

export const winLinkRoutes: RouteObject[] = [{ path: '/w/:winId', element: <WinLinkPage /> }];
